
export interface ModelData {
    id?: number|string;
    order?: number;
  }

export interface SectionData extends ModelData {
    name?: string;
    description?: string;
}

export interface KnifeData extends ModelData {
    name?: string;
    description?: string;
    section?: number|string;
    state?: number;
    price?: number|null;
    photos?: PhotoData[];
}

export interface PhotoData extends ModelData {
    name?: string;
    knife?: number|string;
    src?: string|File;
    thumbnail?: string|File;
}

export class KnifeState {
    public static Undefined = 0;
    public static Available = 1;
    public static Unavailable = 2;
    public static Hidden = 3;

    public static getLabel(state: number): string|undefined {
        return this.KeyLabels.find(pair => pair.key == state)?.label;
    }

    public static KeyLabels = [
        { key: KnifeState.Undefined, label: 'gallery.undefined-state' },
        { key: KnifeState.Available, label: 'gallery.available' },
        { key: KnifeState.Unavailable, label: 'gallery.unavailable' },
        { key: KnifeState.Hidden, label: 'gallery.hidden' },
    ];
}